import { Button, CardMedia, Grid, Paper, Stack } from "@mui/material";
import { FC, useContext } from "react";
import { returnErrorImgSX, ReturnOrderErrorPageFormSX, ReturnOrderFormContainerSX } from "../styles/returnOrder";
import { ContentRecommendation } from "../../ContentRecommendation";
import { useLocalization } from "@/data/Localization";
import { ContentContext } from "@/data/context/content";
import { useReturnRegister } from "@/data/Content/RegisterReturn";
import { RegisterReturnAddressCheckForm } from "@/data/types/ReturnOrder";

export const ReturnErrorPage: FC = () => {
    const returnOrderNLS = useLocalization('ReturnOrder').Labels;

    const {
        returnSteps,
        setActiveReturnStep,
        setReturnAddressValues,
        staticHostSecure
    } = useContext(ContentContext) as ReturnType<typeof useReturnRegister>;

    return (
        <Paper sx={ReturnOrderFormContainerSX}>
            <Stack sx={ReturnOrderErrorPageFormSX}>
                <Stack spacing={3}>
                    <Stack className="return-error-page-header-text">
                        <ContentRecommendation
                            id='Return_order_error_msg_espot'
                            properties={{
                                emsName: 'Return_order_error_msg_espot'
                            }}
                        />
                    </Stack>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Button
                                fullWidth
                                data-testid="return-order-reset-button"
                                id="return-order-reset-button"
                                variant="contained"
                                color="primary"
                                sx={{fontSize:18}}
                                onClick={() => {
                                    setReturnAddressValues({} as RegisterReturnAddressCheckForm);
                                    setActiveReturnStep(returnSteps.addressCheck);
                                }}
                            >
                                {returnOrderNLS.TryAgain.t()}
                            </Button>
                        </Grid>
                    </Grid>
                    <Stack>
                        <ContentRecommendation
                            id='Return_order_error_page_text_espot'
                            properties={{
                                emsName: 'Return_order_error_page_text_espot'
                            }}
                        />
                    </Stack>
                </Stack>
                <Stack>
                    <CardMedia
                        src={`${staticHostSecure}/wcsstore/IntertoysSAS/images/colors/color1/Space.png`} 
                        component='img'
                        sx={returnErrorImgSX}
                    />
                </Stack>
            </Stack>
        </Paper>
    );
}